import { HealthcareBasicData } from '../../../common/HealthcareBasicData';

import { HealthcareFacilityLocationTreeLeaf } from './HealthcareFacilityLocationTreeLeaf';
import { HealthcareFacilityLocationTreeLeavesLoader } from './HealthcareFacilityLocationTreeLeaves.loader';

type HealthcareFacilityLocationTreeLeavesProps = {
   readonly healthcareParentData: HealthcareBasicData;
};

export const HealthcareFacilityLocationTreeLeaves = (props: HealthcareFacilityLocationTreeLeavesProps): JSX.Element => {
   return (
      <HealthcareFacilityLocationTreeLeavesLoader healthcareParentData={props.healthcareParentData}>
         {({ healthcareFacilityLocations, refetchHealthcareFacilityLocations }) => (
            <>
               {healthcareFacilityLocations.map((healthcareFacilityLocation) => (
                  <HealthcareFacilityLocationTreeLeaf
                     key={healthcareFacilityLocation.id}
                     healthcareFacilityLocation={healthcareFacilityLocation}
                     healthcareParentData={props.healthcareParentData}
                     onDataChanged={refetchHealthcareFacilityLocations}
                  />
               ))}
            </>
         )}
      </HealthcareFacilityLocationTreeLeavesLoader>
   );
};
